import { displayMessageAction } from '@app/v2/shared/utils';
import { ApiError } from '@core/api-error';
import { Action } from '@ngrx/store';
import { unknownErrorHandler } from '@servicesV2/apierror-handlers.service';
import { ApiEndPoints } from '@servicesV2/data.service';

export enum AccessRequestEvent {
  AccessRequestCreated = 'AccessRequestCreated',
  Approved = 'Approved',
  Deleted = 'Deleted',
}

export enum AccessRequestErrorCodes {
  UserAlreadyHasAccessToSpecifiedResource = 'UserAlreadyHasAccessToSpecifiedResource',
  TenantArchivedReadOnly = 'TenantArchivedReadOnly',
}

export type AccessRequestErrorValue = keyof typeof AccessRequestErrorCodes;

export interface AccessRequestError {
  errorCode: AccessRequestErrorValue;
}
export interface JoinTenantRequest {
  resourceId: string;
  tenantId: string;
}

export interface JoinTenantToast {
  tenantName?: string;
  resourceName?: string;
}

export interface JoinTenant {
  requestBody: JoinTenantRequest;
  toastBody?: JoinTenantToast;
}

export function handleCreateAccessRequestErrors(apiError: ApiError, _body: any, context: any = {}): Action[] {
  if (!apiError.Url.includes(ApiEndPoints.AccessRequest)) {
    throw new Error('Url mismatch: API url does not match invitations endpoint');
  }

  const errorData: AccessRequestError = apiError.ErrorData as any;

  if (errorData == null) {
    return [unknownErrorHandler()];
  }

  if (errorData.errorCode === AccessRequestErrorCodes.UserAlreadyHasAccessToSpecifiedResource) {
    const message = context.resourceName
      ? `You already have access to ${context.resourceName} in ${context.tenantName}`
      : `You already have access to ${context.tenantName}`;
    return [displayMessageAction(message, 'Info')];
  } else if (errorData.errorCode === AccessRequestErrorCodes.TenantArchivedReadOnly) {
    const message =
      'Your request cannot be delivered. The organization/sub-organization is archived. Please refresh your screen.';
    return [displayMessageAction(message, 'Error')];
  } else {
    return [unknownErrorHandler()];
  }
}

export function handleAccessRequestApprovalErrors(apiError: ApiError, _body: any, _context: any = {}): Action[] {
  if (!apiError.Url.includes(ApiEndPoints.AccessRequest)) {
    throw new Error('Url mismatch: API url does not match access request endpoint');
  }

  const errorData: AccessRequestError = apiError.ErrorData as any;

  if (errorData == null) {
    return [unknownErrorHandler()];
  }

  if (errorData.errorCode === AccessRequestErrorCodes.TenantArchivedReadOnly) {
    const message =
      'The request cannot be approved or dismissed. The organization/sub-organization is archived. Please refresh your screen.';
    return [displayMessageAction(message, 'Error')];
  } else {
    return [unknownErrorHandler()];
  }
}
